import { render, staticRenderFns } from "./RequestInspectionDialog.vue?vue&type=template&id=5d2ff7f0&scoped=true"
import script from "./RequestInspectionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestInspectionDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RequestInspectionDialog.vue?vue&type=style&index=0&id=5d2ff7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2ff7f0",
  null
  
)

export default component.exports